'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Component);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Component.__proto__ || Object.getPrototypeOf(Component)).call.apply(_ref, [this].concat(args))), _this), _this.selectedVar = [], _this.handleReturn = function (value) {
            var returnElements = _this.props.return ? _this.props.return.elements : [];
            var labelElements = [{
                code: 'Label',
                value: '' + value.elements[1].value
            }];
            var selectedValues = returnElements.filter(function (x) {
                return x.value === value.code;
            }) || [];

            if (selectedValues.length > 0) {
                selectedValues = returnElements.filter(function (x) {
                    return x.value !== value.code;
                }) || [];
            } else {
                returnElements.push({
                    code: "Value",
                    value: '' + value.code,
                    elements: labelElements
                });
                selectedValues = returnElements;
            }

            // setting return object
            _this.props.doSetReturn({
                componentCode: _this.props.component.code,
                code: null,
                value: selectedValues
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    // store index of selected list


    _createClass(Component, [{
        key: 'handleCheckBox',


        // invoke when checkbox is clicked and set or append selected index to selectedVar
        value: function handleCheckBox(e, index, inReturn) {
            if (!this.selectedVar.includes(index) && !inReturn) {
                this.selectedVar.push(index);
            } else {
                this.selectedVar = this.selectedVar.filter(function (x) {
                    return x !== index;
                });
            }

            return null;
        }

        // set return object

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var options = (0, _metrixCommon.getElementsByCode)(this.props.component.elements, 'Options');
            return _react2.default.createElement(
                _metrixCommon.Grid,
                null,
                _react2.default.createElement(
                    _metrixCommon.Row,
                    null,
                    options && options.map(function (option, i) {

                        //check all selected value after validating from return (make new function for this)
                        var savedValues = _this2.props.return || [];
                        if (savedValues.hasOwnProperty('elements')) {
                            savedValues = savedValues.elements.map(function (x) {
                                return x.value;
                            });
                        }
                        var inReturn = savedValues.includes(option.code);
                        var check = inReturn || _this2.selectedVar.includes(i);
                        return _react2.default.createElement(
                            _metrixCommon.Column,
                            null,
                            _react2.default.createElement(_metrixCommon.CheckBox, { value: check,
                                clickEvent: function clickEvent(e) {
                                    _this2.handleCheckBox(e, i, inReturn);
                                    _this2.handleReturn(option);
                                },
                                label: option.value,
                                top: _metrixCommon.Sizes.sm
                            })
                        );
                    })
                )
            );
        }
    }]);

    return Component;
}(_react2.default.Component);

exports.default = Component;